import { getDaysAdded } from './getDaysAdded';

export function getNextWeekDay(date = new Date(), weekDay = 1) {
  if (date === null) date = new Date();

  if (date.getDay() !== weekDay)
    return getNextWeekDay(getDaysAdded(date, 1), weekDay);

  return date;
}
